import { Navigation, Pagination, Swiper, Autoplay } from 'swiper';

const testimonialsSections = document.querySelectorAll('section.testimonials');

Array.from(testimonialsSections).forEach(testimonialsSection => {
  const testimonialsSwiperEl = testimonialsSection.querySelector('.testimonials-swiper');
  new Swiper(testimonialsSwiperEl, {
    slidesPerView: 1,
    spaceBetween: 20,
    autoHeight: true,
    breakpoints: {
      992: {
        autoHeight: false,
      },
    },
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 8000,
    },
    // Prevent accidental trackpad sliding
    threshold: 4,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});
